import React, { useContext, useEffect, useState } from 'react';
import { View, colors } from '@fairygodboss/ui';
import window from 'global/window';
import {
    CommunityContext,
    PageContext,
} from '../../../../../../contexts/ContextCreator';
import CommentBoxInput from '../../../../CommentBox/CommentBoxInput/CommentBoxInput';
import { AuthWrapper } from '../../../../../../pages/HomePage_v2/sections/components/AuthWrapper';

export const CommentBox = ({
    type,
    hash,
    setActiveState,
    setCommentText,
    commentText,
    editorRef,
    placeholder,
    isHeaderComment,
    hasLeftImage,
}) => {
    const [mounted, setMounted] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const { fetchMoreComments } = useContext(CommunityContext);
    const { isLoggedIn } = useContext(PageContext);

    useEffect(() => {
        fetchMoreComments(type, hash);
    }, [type, hash, fetchMoreComments]);

    useEffect(() => {
        if (!mounted) {
            setMounted(true);
        }
    }, [mounted]);

    useEffect(() => {
        if (setActiveState) {
            if (!isActive && isHeaderComment) {
                return;
            }
            if (isActive && !isLoggedIn()) {
                editorRef?.current?.blur();
                return;
            }
            setActiveState(isActive);
        }
    }, [isActive, setActiveState, isHeaderComment, isLoggedIn, editorRef]);

    return (
        <View
            id="comment-body"
            css={{
                width: hasLeftImage ? 'calc(100% - 64px)' : '100%',
                '.component-CommentBoxInput': {
                    width: '100%',
                    marginLeft: '0px !important',
                    height: 'inherit',
                },
                '.quill': {
                    border: 'none !important',
                    ':focus': {
                        border: '1px solid red !important',
                    },
                },
                '.componentBoxInput-TextArea': {
                    borderRadius: '4px !important',
                    height: '88px !important',
                },

                '.ql-editor': {
                    padding: '16px !important',
                    fontFamily: 'Open Sans',
                    fontWeight: 400,
                    lineHeight: '24px !important',
                    color: colors.neutral[60],
                    backgroundColor: `${colors.neutral[0]} !important`,
                    minHeight: 'auto !important',
                    borderRadius: '4px !important',
                    border: '1px solid #9DA9BF !important',
                    ':focus': {
                        border: '2px solid #982EA9 !important',
                    },
                    p: {
                        fontFamily: 'Open Sans !important',
                        fontSize: '14px !important',
                    },
                },
                '.ql-editor.ql-blank::before': {
                    color: `${colors.neutral[70]} !important`,
                    opacity: '1 !important',
                    fontFamily: 'Open Sans !important',
                    fontWeight: '400 !important',
                    fontSize: '14px !important',
                },
            }}
        >
            {mounted ? (
                <AuthWrapper
                    component={
                        <CommentBoxInput
                            placeholderText={
                                placeholder || 'Join the conversation...'
                            }
                            handleChange={setCommentText}
                            comment={commentText}
                            onFocus={() => setIsActive(true)}
                            onBlur={() => setIsActive(false)}
                            editorRef={editorRef}
                        />
                    }
                    redirectUrl={window.location.pathname}
                    loginTrigger="comment"
                    customMetric={{ community_on_comment: false }}
                />
            ) : null}
        </View>
    );
};
